/* eslint-disable no-console */

// O aviso de nova versao e disparado por este evento; o App.vue escuta e mostra
// o alerta. Sem ele, quem tem o app instalado pode ficar numa versao antiga sem
// perceber e reportar problema que ja foi corrigido.
export const SW_UPDATE_EVENT = 'onix-sw-updated'

// O Private.vue tambem registra este mesmo arquivo, para configurar o push. Os
// dois registros apontam para o service worker unificado, entao o navegador
// trata como um so.
if (process.env.NODE_ENV === 'production' && navigator.serviceWorker) {
    const serviceWorkerUrl = `${process.env.BASE_URL}service-worker.js`

    // Versão nova baixada e esperando: aplicada sozinha na próxima troca de
    // tela (o app usa hash), sem depender do clique em "Atualizar"
    let pendingRegistration: ServiceWorkerRegistration | null = null

    const notifyUpdate = (registration: ServiceWorkerRegistration) => {
        pendingRegistration = registration
        window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }))
    }

    window.addEventListener('hashchange', () => {
        const waiting = pendingRegistration && pendingRegistration.waiting
        if (!waiting) return

        // O App.vue recarrega a página quando o novo worker assume (controllerchange)
        waiting.postMessage({ type: 'SKIP_WAITING' })
        pendingRegistration = null
    })

    navigator.serviceWorker.register(serviceWorkerUrl)
        .then((registration) => {
            console.log('Service worker registrado.')

            // Abas abertas por muito tempo também procuram versão nova:
            // a cada 5 minutos e sempre que a aba volta a ficar visível
            const checkForUpdate = () => registration.update().catch(() => {})
            setInterval(checkForUpdate, 5 * 60 * 1000)
            window.addEventListener('focus', checkForUpdate)
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') checkForUpdate()
            })

            if (registration.waiting) {
                notifyUpdate(registration)
                return
            }

            registration.addEventListener('updatefound', () => {
                console.log('Baixando nova versao...')

                const worker = registration.installing
                if (!worker) return

                worker.addEventListener('statechange', () => {
                    if (worker.state === 'installed' && navigator.serviceWorker.controller) {
                        console.log('Nova versao disponivel.')
                        notifyUpdate(registration)
                    }
                })
            })
        })
        .catch((error) => {
            console.error('Erro no service worker:', error)
        })
}

// Em desenvolvimento, remove service workers que tenham sobrado de um build de
// producao rodado no mesmo endereco - eles interceptam o dev server e quebram o
// carregamento das telas com "ChunkLoadError: Loading chunk failed".
if (process.env.NODE_ENV !== 'production' && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => {
            const worker = registration.active || registration.waiting || registration.installing
            const scriptUrl = worker && worker.scriptURL ? worker.scriptURL : ''

            // Os do OneSignal continuam: o push funciona tambem em desenvolvimento
            if (scriptUrl.includes('OneSignalSDK')) return

            registration.unregister()
        })
    })
}
